<!--
  Displays an error message next/below to an input field.
  - Uses aria-live and role="alert" (which are the same thing) to notify screen readers of critical error message.
    - These shouldn't be used for errors when validation happens later or other non-critical errors. 
    - If non-critical errors are used, implement aria-live="polite" and role="" instead to this component. 
  - The parent div with aria labels must exist in the initial render. Only the content will be shown or not shown.  
  - Usage:
    <input type="text" aria-describedby="error-id" :aria-invalid="!isValid">
    <input-error id="error-id" :show="!isValid">Error message</input-error>

  Props:
    - show: boolean (required) — Whether to show the error message.
    - showIcon: boolean (optional) — Whether to show the info icon and use black text
-->
<template>
  <div
    class="input-error"
    :class="{ red: !showIcon }"
    :aria-hidden="!show"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div v-if="show">
      <i v-if="showIcon" class="icon-info"></i>
      <span><slot></slot></span>
    </div>
  </div>
</template>
<script setup lang="ts">
const { show, showIcon } = defineProps({
  show: { type: Boolean, required: true },
  showIcon: { type: Boolean, required: false },
});
</script>
<style>
.input-error {
  display: inline-flex;
  align-items: top;
  font: var(--error-input);

  &.red {
    color: var(--negative);
  }

  i {
    font-size: var(--icon-size-medium);
    line-height: 20px;
  }
}
</style>
